import editingOperations from "./batchOperations.editing";
import readonlyOperations from "./batchOperations.readonly";

let batchOperations = readonlyOperations;
//#!if readonly !== true
// batchOperations = Object.assign(batchOperations, editingOperations);
//#!endif

export default batchOperations;
